<template>
  <div class="number-info-body">
    <div class="number-info-title">
      <span :class="{ active: numberType === 0 }" @click="numberType = 0"
        ><a-icon type="mobile" /> 手机找回</span
      >
      <span :class="{ active: numberType === 1 }" @click="numberType = 1"
        ><a-icon type="mail" /> 邮箱找回</span
      >
    </div>
    <mobile-reset
      ref="mobileForm"
      v-if="numberType === 0"
      @success="registerSuccess"
    ></mobile-reset>
    <email-reset
      ref="emailForm"
      v-else
      @success="registerSuccess"
    ></email-reset>
    <div class="number-info-footer">
      <a-button @click="resetSubmit">提 交</a-button>
      <!--      <a-button v-if="numberType === 0" @click="resetSubmit">提 交</a-button>-->
      <!--      <a-button v-else @click="emailReset">邮件发送成功</a-button>-->
    </div>
  </div>
</template>

<script>
import MobileReset from "@/page/resetPassword/modules/MobileReset";
import EmailReset from "@/page/resetPassword/modules/EmailReset";

export default {
  components: {
    MobileReset,
    EmailReset,
  },
  data() {
    return {
      numberType: 0,
      checkbox: false,
    };
  },
  methods: {
    resetSubmit() {
      const { numberType } = this;
      if (numberType === 0) {
        this.$refs.mobileForm.submit();
      } else {
        this.$refs.emailForm.submit();
      }
    },
    emailReset() {
      this.$success({
        title: "邮件发送成功！",
        width: "520px",
        content: (
          <div>
            <p style="margin-bottom:4px">
              我们已向XXXXXXXXX@qq.com发送了重置密码邮件。
            </p>
            <p>请登录邮箱重置密码。邮箱可能有延迟，请稍等1~2分钟。</p>
          </div>
        ),
      });
    },
    seeAgreement(url) {
      window.open(url, "_blank");
    },
    registerSuccess(/*data*/) {
      this.$router.push("/");
      // this.$emit("success", data);
    },
  },
};
</script>

<style lang="less" scoped>
.btn-gray {
  background: gray !important;
  color: #fff !important;
}

.number-info-body {
  height: 100%;
  width: 640px;
  margin: 0 auto;
  padding: 40px 0;

  .number-info-title {
    display: flex;
    border-bottom: 1px solid #f0f0f0;

    > span {
      flex: 1;
      height: 56px;
      line-height: 56px;
      border-bottom: 2px solid transparent;
      text-align: center;
      cursor: pointer;
      font-size: 16px;
      transition: all 0.3s;

      &.active {
        border-color: #1abc9c;
        color: #1abc9c;
      }
    }
  }

  .number-info-footer {
    > button {
      display: block;
      width: 100%;
      height: 48px;
      background: #1abc9c;
      border-color: #1abc9c;
      border-radius: 2px;
      font-size: 16px;
      color: #fff;
      margin-bottom: 24px;
    }

    > p {
      display: flex;
      align-items: center;

      .number-info-footer-xy {
        color: #1abc9c;
        cursor: pointer;
      }
    }
  }
}
</style>
